export default __webpack_public_path__ + "static/media/chicken.0bf00278.928a3a7b.svg";